import { render } from "./TheSpotlight.vue?vue&type=template&id=d5d80412&scoped=true&ts=true"
import script from "./TheSpotlight.vue?vue&type=script&lang=ts"
export * from "./TheSpotlight.vue?vue&type=script&lang=ts"

import "./TheSpotlight.vue?vue&type=style&index=0&id=d5d80412&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5d80412"]])

export default __exports__